import React from 'react';
import { TeamMembers } from 'components';

const TeamComponent = (props) => {
    return <TeamMembers {...props} />;
};

export default TeamComponent;
